const CurrencySymbols = {
  USD: '$',
  RUB: '₽',
  EUR: '€',
  DRM: '֏',
  XTS: 'XTS',
};

export default CurrencySymbols;
